import { render, staticRenderFns } from "./PromotionView.vue?vue&type=template&id=13d1f1a1"
import script from "@/scripts/promotions/promotionsView.js?vue&type=script&lang=js&external"
export * from "@/scripts/promotions/promotionsView.js?vue&type=script&lang=js&external"
import style0 from "./PromotionView.vue?vue&type=style&index=0&id=13d1f1a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports